<!-- Поле типа заказа со ссылкой на справочник и быстрым созданием значения. -->
<template>
  <BaseFormField
    class="order-type-field"
    label="Тип заказа"
    for-id="order_type_id"
  >
    <template #action>
      <BaseActionLink :to="{ name: 'ReferenceItems' }">
        Справочник
      </BaseActionLink>
    </template>

    <ReferenceItemSelect
      id="order_type_id"
      :model-value="modelValue"
      target-model="Order"
      target-field="order_type"
      placeholder="Выберите тип заказа"
      :with-button="true"
      button-label="Создать новый тип"
      :clearable="false"
      @update:modelValue="$emit('update:modelValue', $event)"
      @change="$emit('change', $event)"
    />
  </BaseFormField>
</template>

<script>
import ReferenceItemSelect from "@/components/ReferenceItem/ReferenceItemSelect.vue";

export default {
  name: "OrderTypeField",

  components: {
    ReferenceItemSelect,
  },

  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
  },

  emits: ["change", "update:modelValue"],
};
</script>

<style scoped>
.order-type-field {
  min-width: 0;
  width: 100%;
}

.order-type-field :deep(.custom-select),
.order-type-field :deep(.select-trigger) {
  min-width: 0;
  width: 100%;
}
</style>
